/**
 * @TODO: Evaluate an EventTarget and CustomEvent replacement for a Node.js
 * EventEmitter replacement, which would likely be much more performant:
 *
 * export class NativeEventEmitter extends EventTarget {}
 * const nativeEventEmitter = new NativeEventEmitter()
 * nativeEventEmitter.addEventListener('custom', (event) => console.log(`CUSTOM EVENT: ${event}`))
 * nativeEventEmitter.dispatchEvent(new CustomEvent('custom', { detail: 'Hi!' }))
 */
export class EventEmitter {

  public callbacks: { [key: string]: Function[] } = {}

  public on(event: string, fn: Function): this {
    if (!this.callbacks[event]) {
      this.callbacks[event] = []
    }

    this.callbacks[event].push(fn)

    return this
  }

  protected emit(event: string, ...args: any): this {
    const callbacks = this.callbacks[event]

    if (callbacks) {
      callbacks.forEach(callback => callback.apply(this, args))
    }

    return this
  }

  public off(event: string, fn?: Function): this {
    const callbacks = this.callbacks[event]

    if (callbacks) {
      if (fn) {
        this.callbacks[event] = callbacks.filter(callback => callback !== fn)
      } else {
        delete this.callbacks[event]
      }
    }

    return this
  }

  removeAllListeners(): void {
    this.callbacks = {}
  }
}
